import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/config";

const WorkTeaser = () => {
  const preview = [
    {
      url: BUSINESS.gallery.commercial[0].url,
      tag: "Commercial",
      caption: "Washroom installation",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/k4kxfsgb_WhatsApp%20Image%202026-06-23%20at%2011.40.59.jpeg",
      tag: "Domestic",
      caption: "Bathroom refurbishment",
    },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-[#151D33] border-y border-[#2C374D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4">
              / 02 — Our Work
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95] tracking-tight">
              REAL JOBS.
              <br />
              <span className="text-[#D47A4A]">REAL RESULTS.</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#A0ABC0] max-w-md">
            A glimpse of recent commercial fit-outs and domestic before-and-after
            refurbishments across Edinburgh.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {preview.map((p, i) => (
            <motion.figure
              key={p.url}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-md border border-[#2C374D] hover:border-[#D47A4A]/60 transition-colors bg-[#0B132B]"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={p.url}
                  alt={p.caption}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700 ease-out"
                />
              </div>
              <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-md bg-[#D47A4A] text-[#0B132B] shadow-md">
                {p.tag}
              </span>
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0B132B] via-[#0B132B]/40 to-transparent p-4 md:p-5">
                <p className="font-display text-base md:text-lg text-white tracking-wide">
                  {p.caption.toUpperCase()}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-10 md:mt-14 flex justify-center md:justify-start">
          <Link
            to="/our-work"
            data-testid="home-work-view-more"
            className="group inline-flex items-center gap-2 bg-[#D47A4A] hover:bg-[#B85D2A] text-[#0B132B] font-bold px-6 py-3 rounded-md transition-all uppercase tracking-wider text-sm shadow-md shadow-[#D47A4A]/20 hover:shadow-[#D47A4A]/40 hover:-translate-y-0.5"
          >
            View Full Gallery
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WorkTeaser;
